import { API_USERS_URL } from './endpoints'

const TOKEN_KEY = 'consultapp_auth_token'
const USER_KEY = 'consultapp_current_user'
const EXPIRES_AT_KEY = 'consultapp_auth_expires_at'

const parseJson = async (response) => {
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    throw new Error(data?.message || `HTTP ${response.status}`)
  }
  return data
}

export const login = async ({ usuario, password }) => {
  const data = await fetch(`${API_USERS_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ usuario, password }),
  }).then(parseJson)

  const authenticatedUser = data.usuario || data.user
  if (!data.token || !authenticatedUser) {
    throw new Error('La API de usuarios no devolvio una sesion valida.')
  }

  localStorage.setItem(TOKEN_KEY, data.token)
  localStorage.setItem(USER_KEY, JSON.stringify(authenticatedUser))
  if (data.expires_at) {
    localStorage.setItem(EXPIRES_AT_KEY, data.expires_at)
  }
  return { ...data, usuario: authenticatedUser }
}

export const logout = () => {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(EXPIRES_AT_KEY)
  localStorage.removeItem('consultapp_user')
}

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY)

const parseTokenPayload = (token) => {
  try {
    const parts = token.split('.')
    const payload = parts.length === 3 ? parts[1] : parts.length === 2 ? parts[0] : null
    if (!payload) return null
    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/')
    const paddedPayload = normalizedPayload.padEnd(
      normalizedPayload.length + ((4 - (normalizedPayload.length % 4)) % 4),
      '=',
    )
    return JSON.parse(window.atob(paddedPayload))
  } catch {
    return null
  }
}

export const getCurrentUser = () => {
  try {
    const storedUser = localStorage.getItem(USER_KEY) || localStorage.getItem('consultapp_user')
    return storedUser ? JSON.parse(storedUser) : null
  } catch {
    return null
  }
}

export const withCurrentUser = (payload = {}) => {
  const currentUser = getCurrentUser()
  const tokenUserId = parseTokenPayload(getAuthToken())?.sub
  const userId =
    payload.user_id ??
    payload.usuario_id ??
    currentUser?.id ??
    currentUser?.user_id ??
    currentUser?.usuario_id ??
    tokenUserId
  return {
    ...payload,
    user_id: userId,
    usuario_id: userId,
  }
}

export const isAuthenticated = () => {
  const token = getAuthToken()
  const user = getCurrentUser()
  const payload = token ? parseTokenPayload(token) : null
  const expiresAt = localStorage.getItem(EXPIRES_AT_KEY)
  const isValidToken = Boolean(
    (payload?.exp && Number(payload.exp) * 1000 > Date.now()) ||
      (expiresAt && Date.parse(expiresAt) > Date.now()),
  )

  if (!user || !isValidToken) {
    logout()
    return false
  }

  return true
}
